$(document).ready(function () {
  const myAccrodion = new HandyCollapse();
})